import { TimePicker as iTimePicker , Poptip as iPoptip} from 'iview'
import RangeTimePickerPanel from 'iview/src/components/date-picker/panel/Time/time-range'

const isPromise = v => Object.prototype.toString.call(v) == '[object Promise]' 

const str2time = d => {
  return d.split(':').reverse().reduce((t,c,idx) => (t + Math.pow(60 , idx) * parseInt(c)),0)
}

const zeroize = (v) => {
  v = parseInt(v)
  return v < 10 ? "0" + v : v;
}

const format = (a , expr) => {
  if (expr == 'timestamp' || expr == 'ms') {
    return a.getTime()
  }

  if(expr == 'date'){
    return a
  }

  let y = a.getFullYear(),
    M = a.getMonth() + 1,
    d = a.getDate(),
    D = a.getDay(),
    h = a.getHours(),
    m = a.getMinutes(),
    s = a.getSeconds(),
    w = a.getDay();

  return expr.replace(/(?:s{1,2}|w{1,2}|m{1,2}|h{1,2}|d{1,2}|M{1,4}|y{1,4})/g, function(str) {

    switch (str) {
      case 's':
        return s;
      case 'ss':
        return zeroize(s);
      case 'm':
        return m;
      case 'mm':
        return zeroize(m);
      case 'h':
        return h;
      case 'hh':
        return zeroize(h);
      case 'd':
        return d;
      case 'w':
        return w;
      case 'ww':
        return w == 0 ? 7 : w;
      case 'dd':
        return zeroize(d);
      case 'M':
        return M;
      case 'MM':
        return zeroize(M);
      case 'MMMM':
        return ['十二', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一'][m] + '月';
      case 'yy':
        return String(y).substr(2);
      case 'yyyy':
        return y;
      default:
        return str.substr(1, str.length - 2);
    }
  })
}

const parser = (v) => {
  v = v.split(':').map(i => parseInt(i) )
  let a = new Date()
  a.setHours(v[0])
  a.setMinutes(v[1])
  a.setSeconds(v[2])
  a.setMilliseconds(0)
  return a
}

import './style.scss'
export const TimeRangePicker = {
  name:'TimeRangePicker',
  props:['value','filter','steps'],
  data(){
    return {
      open:true,
      currentValue:[],
      visible:false,
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if(nv && nv.length == 2){
        console.log(...nv)
        this.currentValue = nv.map(parser)
      }
    },{immediate:true})
  },
  methods:{
    onChange(v){
      this.currentValue = [...v]
    },
    onOk(){
      let d = this.currentValue.map( i => format(i , 'hh:mm:ss') );
      if( this.filter && typeof this.filter === 'function' ){
        let process = this.filter([...d])
        if( isPromise(process) ){
          process.then(resp => {
            if( resp ){
              this.$emit('change' , [...d])
              this.visible = false
            }
          })
        }else{
          if( process !== false){
            this.$emit('change' , [...d])
              this.visible = false
          }
        }
      }else{
        this.$emit('change' , [...d])
        this.visible = false
      }
    }
  },
  render(){
    const { $scopedSlots } = this
    const slots = {
      default:() => {
        return $scopedSlots.default ? $scopedSlots.default() : null
      },
      content:()=>{
        return (
          <div class="sl-time-picker" >
            <RangeTimePickerPanel steps={this.steps} value={this.currentValue} on-on-pick={this.onChange} />
            <div class="sl-time-picker-footer">
              <Button size="small" type="primary" on-click={this.onOk}>确定</Button>
            </div>
          </div>
        )
      }
    }
    //RangeTimePickerPanel
    return <Poptip on-on-popper-hide={()=>{this.visible = false}} on-on-popper-show={()=>{this.visible=true}} padding="0" value={this.visible} transfer={true} scopedSlots={slots}></Poptip>

    return (
      <Dropdown trigger="click" transfer-class-name='sl-time-picker-rel-poptip' transfer={true} scopedSlots={slots}>
      </Dropdown>
    )
  }
}

export const TimePicker = {
  name:'TimePicker',
  props:['value','filter','format'],
  data(){
    return {
      currentValue:null,
      tmpValue:null,
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if(nv){
        this.currentValue = this.tmpValue = nv
      }else{
        this.currentValue = this.tmpValue = null
      }
    },{immediate:true})
  },
  methods:{
    handleChange(v){
      if( this.filter ){
        let res = this.filter(v)
        if( res !== false){
          this.currentValue = v
        }else{
          this.tmpValue = this.currentValue
        }
      }
     
    },
    
    handleClose(open){
      if( !open  ){
        //this.tmpValue = this.currentValue
        this.$emit('change' , this.currentValue)
        this.$emit('input' , this.currentValue)
      }
    }
  },
  render(){
    const { $scopedSlots } = this
    return <iTimePicker editable={false} format={this.format} on-on-change={this.handleChange} v-model={this.tmpValue} on-on-open-change={this.handleClose}>
    </iTimePicker>
  }
}